const updateAuthUser = (state, { payload: { user } }) => {
	state.user = user;
};

export default updateAuthUser;
